import type { AiInterviewSessionWithArtifacts, AiInterviewStoredMessage } from '@core/supabase/services/aiInterviewSessionService';

export type InterviewAttemptSlice = {
  /** 1-based index within this session (across archived + current). */
  index: number;
  isCurrent: boolean;
  messages: AiInterviewStoredMessage[];
  recordingPath: string | null;
};

/** Build chronological attempts: archived first (oldest), then current row (in progress or latest). */
export function listInterviewAttempts(session: AiInterviewSessionWithArtifacts): InterviewAttemptSlice[] {
  const priors = session.prior_attempts ?? [];
  const out: InterviewAttemptSlice[] = [];
  let idx = 1;
  for (const p of priors) {
    out.push({
      index: idx,
      isCurrent: false,
      messages: p.messages ?? [],
      recordingPath: p.recording_storage_path?.trim() ? p.recording_storage_path.trim() : null,
    });
    idx += 1;
  }
  const curMessages = session.messages ?? [];
  const curPath = session.recording_storage_path?.trim() ?? '';
  const hasCurrentContent = curMessages.length > 0 || curPath.length > 0;
  if (hasCurrentContent || priors.length > 0) {
    out.push({
      index: idx,
      isCurrent: true,
      messages: curMessages,
      recordingPath: curPath.length > 0 ? curPath : null,
    });
  }
  return out;
}

export function transcriptLabel(n: number, isCurrent: boolean, hasPrior: boolean): string {
  if (!hasPrior && isCurrent) return 'Transcript 1';
  return isCurrent ? `Transcript ${n} (current)` : `Transcript ${n}`;
}

export function recordingLabel(n: number, isCurrent: boolean, hasPrior: boolean): string {
  if (!hasPrior && isCurrent) return 'Recording 1';
  return isCurrent ? `Recording ${n} (current)` : `Recording ${n}`;
}
